// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Vsh2","colBig":"styles_colBig__bWz6c","colSmall":"styles_colSmall__2Kaim"};